(function () {
  function updatePreorderEta(variantId) {
    document.querySelectorAll('[data-norgain-preorder-eta]').forEach(function (wrapper) {
      var anyVisible = false;
      wrapper.querySelectorAll('.norgain-preorder-eta').forEach(function (block) {
        var match = block.dataset.variantId === String(variantId);
        block.hidden = !match;
        if (match) anyVisible = true;
      });
      // skladová varianta => žádný blok se nezobrazí, wrapper zůstane prázdný
      wrapper.style.display = anyVisible ? '' : 'none';
    });
  }

  // Dawn publikuje změnu varianty přes pub/sub (novější verze)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event.data && event.data.variant;
      if (variant) updatePreorderEta(variant.id);
    });
  }

  // Fallback: sledování změny URL parametru ?variant= (funguje ve všech verzích Dawn)
  var lastVariant = new URLSearchParams(location.search).get('variant');
  setInterval(function () {
    var v = new URLSearchParams(location.search).get('variant');
    if (v && v !== lastVariant) {
      lastVariant = v;
      updatePreorderEta(v);
    }
  }, 300);
})();